/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationCombos200ResponseItemsInner } from './GetLocationCombos200ResponseItemsInner';
import {
    GetLocationCombos200ResponseItemsInnerFromJSON,
    GetLocationCombos200ResponseItemsInnerFromJSONTyped,
    GetLocationCombos200ResponseItemsInnerToJSON,
    GetLocationCombos200ResponseItemsInnerToJSONTyped,
} from './GetLocationCombos200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetLocationCombos200Response
 */
export interface GetLocationCombos200Response {
    /**
     * 
     * @type {Array<GetLocationCombos200ResponseItemsInner>}
     * @memberof GetLocationCombos200Response
     */
    items: Array<GetLocationCombos200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLocationCombos200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationCombos200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationCombos200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetLocationCombos200Response interface.
 */
export function instanceOfGetLocationCombos200Response(value: object): value is GetLocationCombos200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetLocationCombos200ResponseFromJSON(json: any): GetLocationCombos200Response {
    return GetLocationCombos200ResponseFromJSONTyped(json, false);
}

export function GetLocationCombos200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationCombos200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetLocationCombos200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetLocationCombos200ResponseToJSON(json: any): GetLocationCombos200Response {
    return GetLocationCombos200ResponseToJSONTyped(json, false);
}

export function GetLocationCombos200ResponseToJSONTyped(value?: GetLocationCombos200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetLocationCombos200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

